/* PREPOPULATE PRODUCT FROM PDP WIDGET **********************************************************************/

(function () {
  var bundlePagePath =
    window.PXUTheme &&
    window.PXUTheme.theme_settings &&
    window.PXUTheme.theme_settings.bundles_page
      ? window.PXUTheme.theme_settings.bundles_page
      : '/products/london-lash-bundle';

  var checkIntervalMs = 300;
  var maxWaitMs = 20000;

  function normalizePath(path) {
    return String(path || '').replace(/\/$/, '');
  }

  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&amp;/g, '&')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isRechargeBundlesPage() {
    return normalizePath(window.location.pathname) === normalizePath(bundlePagePath);
  }

  function getSourceProduct() {
    var savedProduct = sessionStorage.getItem('bundleSourceProduct');

    if (!savedProduct) {
      console.log('[Bundle auto-select] No saved source product found');
      return null;
    }

    try {
      return JSON.parse(savedProduct);
    } catch (error) {
      console.log('[Bundle auto-select] Could not parse saved product', error);
      return null;
    }
  }

  function isVisible(element) {
    return !!(
      element &&
      element.offsetParent !== null &&
      getComputedStyle(element).visibility !== 'hidden' &&
      getComputedStyle(element).display !== 'none'
    );
  }

  function getButtonText(button) {
    return normalizeText(
      button.innerText ||
      button.textContent ||
      button.value ||
      button.getAttribute('aria-label') ||
      button.getAttribute('title')
    );
  }

  function isAddButton(button) {
    return isVisible(button) && getButtonText(button) === 'add';
  }

  function getAddButtonsInside(element) {
    var buttons = element.querySelectorAll('button, [role="button"]');

    return Array.prototype.filter.call(buttons, function (button) {
      return isAddButton(button);
    });
  }

  function clickRechargeButton(button) {
    button.scrollIntoView({
      block: 'center',
      inline: 'center'
    });

    button.focus();

    if (window.PointerEvent) {
      button.dispatchEvent(new PointerEvent('pointerdown', {
        bubbles: true,
        cancelable: true,
        view: window
      }));
    }

    button.dispatchEvent(new MouseEvent('mousedown', {
      bubbles: true,
      cancelable: true,
      view: window
    }));

    if (window.PointerEvent) {
      button.dispatchEvent(new PointerEvent('pointerup', {
        bubbles: true,
        cancelable: true,
        view: window
      }));
    }

    button.dispatchEvent(new MouseEvent('mouseup', {
      bubbles: true,
      cancelable: true,
      view: window
    }));

    button.click();
  }

  function findMatchingAddButton(sourceProduct) {
    var sourceTitle = normalizeText(sourceProduct.title);
    var sourceHandleAsWords = normalizeText(
      String(sourceProduct.handle || '').replace(/-/g, ' ')
    );

    console.log('[Bundle auto-select] Looking for title:', sourceProduct.title);
    console.log('[Bundle auto-select] Normalized title:', sourceTitle);
    console.log('[Bundle auto-select] Normalized handle:', sourceHandleAsWords);

    var allElements = document.querySelectorAll('body *');
    var titleMatches = [];

    for (var i = 0; i < allElements.length; i++) {
      var element = allElements[i];

      if (!isVisible(element)) {
        continue;
      }

      var elementText = normalizeText(element.innerText || element.textContent);

      if (!elementText) {
        continue;
      }

      if (sourceTitle && elementText.includes(sourceTitle)) {
        titleMatches.push(element);
        continue;
      }

      if (sourceHandleAsWords && elementText.includes(sourceHandleAsWords)) {
        titleMatches.push(element);
      }
    }

    titleMatches.sort(function (a, b) {
      var aText = normalizeText(a.innerText || a.textContent);
      var bText = normalizeText(b.innerText || b.textContent);

      return aText.length - bText.length;
    });

    console.log('[Bundle auto-select] Title matching elements found:', titleMatches.length);

    for (var j = 0; j < titleMatches.length; j++) {
      var titleElement = titleMatches[j];
      var current = titleElement;
      var levelsChecked = 0;

      while (current && current !== document.body && levelsChecked < 12) {
        var addButtons = getAddButtonsInside(current);

        if (addButtons.length === 1) {
          console.log('[Bundle auto-select] Matching product card found:', current);
          console.log('[Bundle auto-select] Matching Add button found:', addButtons[0]);

          return addButtons[0];
        }

        if (addButtons.length > 1) {
          break;
        }

        current = current.parentElement;
        levelsChecked++;
      }
    }

    console.log('[Bundle auto-select] No matching Add button found');

    return null;
  }

  function autoSelectSourceProduct() {
    var sourceProduct = getSourceProduct();

    if (!sourceProduct || !sourceProduct.title) {
      console.log('[Bundle auto-select] Missing source product title:', sourceProduct);
      return false;
    }

    var addButton = findMatchingAddButton(sourceProduct);

    if (!addButton) {
      return false;
    }

    console.log('[Bundle auto-select] Clicking Add button for:', sourceProduct.title);

    clickRechargeButton(addButton);

    return true;
  }

  if (!isRechargeBundlesPage()) {
    return;
  }

  var sourceProduct = getSourceProduct();

  console.log('[Bundle auto-select] Bundle page detected:', window.location.pathname);
  console.log('[Bundle auto-select] Source product:', sourceProduct);

  if (!sourceProduct || !sourceProduct.title) {
    return;
  }

  var startedAt = Date.now();

  var checkForProduct = setInterval(function () {
    var selected = autoSelectSourceProduct();

    if (selected) {
      clearInterval(checkForProduct);
      return;
    }

    if (Date.now() - startedAt > maxWaitMs) {
      clearInterval(checkForProduct);

      console.log('[Bundle auto-select] Stopped waiting for matching product:', sourceProduct);
    }
  }, checkIntervalMs);
})();

/* SEARCH BAR - SHOPIFY + RECHARGE HYBRID SEARCH / DROPDOWN RESULTS ***************/

(function () {
  var bundlePagePath =
    window.PXUTheme &&
    window.PXUTheme.theme_settings &&
    window.PXUTheme.theme_settings.bundles_page
      ? window.PXUTheme.theme_settings.bundles_page
      : '/products/london-lash-bundle';

  var searchBarId = 'bundle-search-bar';
  var searchFormId = 'bundle-search-form';
  var searchInputWrapId = 'bundle-search-input-wrap';
  var searchInputId = 'bundle-search-input';
  var searchClearId = 'bundle-search-clear';
  var searchSubmitId = 'bundle-search-submit';
  var searchResultsId = 'bundle-search-results';
  var searchCountId = 'bundle-search-count';
  var searchPlaceholderId = 'bundle-search-placeholder';
  var searchStickyTitleId = 'bundle-search-sticky-title';
  var collectionControlsPlaceholderId = 'bundle-collection-controls-placeholder';
  var highlightClass = 'bundle-search-highlight';

  var shopifySearchTimeout = null;
  var latestSearchRequestId = 0;

  /*
    Controls how long to wait after typing before searching.
    3000 = 3 seconds
    2000 = 2 seconds
    1500 = 1.5 seconds
  */
  var searchTypingDelayMs = 1000;

  function normalizePath(path) {
    return String(path || '').replace(/\/$/, '');
  }

  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&amp;/g, '&')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getSearchTokens(searchTerm) {
    return normalizeText(searchTerm)
      .split(' ')
      .filter(function (token) {
        return token.length > 1;
      });
  }

  function tokenMatchesText(token, text) {
    if (!token || !text) {
      return false;
    }

    if (text.includes(token)) {
      return true;
    }

    if (text.includes(token + 's')) {
      return true;
    }

    if (text.includes(token + 'es')) {
      return true;
    }

    if (token.endsWith('y') && text.includes(token.slice(0, -1) + 'ies')) {
      return true;
    }

    if (token.length > 3 && text.includes(token.slice(0, -1))) {
      return true;
    }

    return false;
  }

  function relaxedTextMatches(searchTerm, text) {
    var tokens = getSearchTokens(searchTerm);
    var normalizedText = normalizeText(text);

    if (!tokens.length || !normalizedText) {
      return false;
    }

    return tokens.every(function (token) {
      return tokenMatchesText(token, normalizedText);
    });
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function isRechargeBundlesPage() {
    return normalizePath(window.location.pathname) === normalizePath(bundlePagePath);
  }

  function findChooseAtLeastTitle() {
    return document.querySelector('.recharge-bundle-variant-size-title');
  }

  function getProductCells() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[role="gridcell"][aria-label^="Product "]')
    );
  }

  function getProductName(cell) {
    var heading = cell.querySelector('.recharge-bundle-product-titles [role="heading"]');

    if (heading) {
      return (
        heading.getAttribute('aria-label') ||
        heading.innerText ||
        heading.textContent ||
        ''
      ).trim();
    }

    var ariaLabel = cell.getAttribute('aria-label') || '';
    var match = ariaLabel.match(/Product\s+\d+\s+of\s+\d+:\s*(.*)/i);

    return match ? match[1].trim() : ariaLabel.trim();
  }

  function getProductText(cell) {
    return normalizeText(
      (cell.getAttribute('aria-label') || '') + ' ' +
      (cell.innerText || cell.textContent || '')
    );
  }

  function getProductPrice(cell) {
    var price = cell.querySelector('[aria-label^="Actual price"]');

    if (!price) {
      return '';
    }

    return (
      price.innerText ||
      price.textContent ||
      price.getAttribute('aria-label') ||
      ''
    ).replace('Actual price', '').trim();
  }

  function getProductImage(cell) {
    var img = cell.querySelector('img');
    return img ? img.src : '';
  }

  function getShopifyProductImage(product) {
    if (!product) {
      return '';
    }

    if (product.featured_image) {
      if (typeof product.featured_image === 'string') {
        return product.featured_image;
      }

      if (product.featured_image.url) {
        return product.featured_image.url;
      }
    }

    if (product.image) {
      if (typeof product.image === 'string') {
        return product.image;
      }

      if (product.image.url) {
        return product.image.url;
      }
    }

    return '';
  }

  function injectSearchStyles() {
    var existingStyles = document.getElementById('bundle-search-styles');

    if (existingStyles) {
      existingStyles.remove();
    }

    var style = document.createElement('style');
    style.id = 'bundle-search-styles';

    style.textContent = `
      #bundle-search-bar,
      #bundle-search-form,
      #bundle-search-input-wrap,
      #bundle-search-input,
      #bundle-search-clear,
      #bundle-search-submit {
        box-sizing: border-box;
      }

      #bundle-search-bar {
        margin: 10px 0 12px;
        position: relative;
        width: 100%;
      }

      #bundle-search-form {
        display: flex;
        align-items: stretch;
        gap: 6px;
        width: 100%;
      }

      #bundle-search-input-wrap {
        position: relative;
        flex: 1;
        min-width: 0;
      }

      #bundle-search-input {
        width: 100%;
        height: 42px;
        padding: 9px 40px 9px 12px;
        border: 1px solid #ddd;
        border-radius: 4px;
        font-size: 14px;
      }

      #bundle-search-input:focus {
        outline: none;
        border-color: #111;
      }

      #bundle-search-clear {
        display: none;
        position: absolute;
        top: 50%;
        right: 6px;
        transform: translateY(-50%);
        width: 28px;
        min-width: 28px;
        height: 28px;
        padding: 0;
        border: 0;
        border-radius: 50%;
        background: transparent;
        color: #777;
        font-size: 20px;
        line-height: 1;
        cursor: pointer;
      }

      #bundle-search-clear:hover {
        color: #111;
        background: #f3f3f3;
      }

      #bundle-search-clear.is-visible {
        display: block;
      }

      #bundle-search-submit {
        width: 48px;
        min-width: 48px;
        height: 42px;
        padding: 0;
        border: 0;
        border-radius: 4px;
        background: #111;
        color: #fff;
        font-size: 0;
        font-weight: 700;
        cursor: pointer;
        white-space: nowrap;
        position: relative;
      }

      #bundle-search-submit::before {
        content: "⌕";
        font-size: 22px;
        line-height: 1;
      }

      #bundle-search-count {
        margin-top: 6px;
        font-size: 12px;
        opacity: 0.7;
      }

      #bundle-search-results {
        display: none;
        margin-top: 8px;
        border: 1px solid #ddd;
        border-radius: 4px;
        background: #fff;
        max-height: 320px;
        overflow: auto;
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
        z-index: 5;
      }

      .bundle-search-result {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
        padding: 9px;
        border-bottom: 1px solid #eee;
        background: #fff;
        text-align: left;
        box-sizing: border-box;
      }

      .bundle-search-result:last-child {
        border-bottom: 0;
      }

      .bundle-search-result:hover {
        background: #f7f7f7;
      }

      .bundle-search-result.is-disabled {
        opacity: 0.55;
      }

      .bundle-search-result img {
        width: 48px;
        height: 48px;
        object-fit: cover;
        flex: 0 0 48px;
      }

      .bundle-search-result__main {
        flex: 1;
        min-width: 0;
      }

      .bundle-search-result__title {
        font-weight: 700;
        font-size: 13px;
        line-height: 1.25;
      }

      .bundle-search-result__meta {
        margin-top: 3px;
        font-size: 12px;
        opacity: 0.75;
      }

      .bundle-search-result__action {
        padding: 8px 10px;
        border: 0;
        border-radius: 3px;
        background: #111;
        color: #fff;
        font-size: 11px;
        font-weight: 700;
        cursor: pointer;
        white-space: nowrap;
      }

      .bundle-search-result__action--secondary {
        background: #fff;
        color: #111;
        border: 1px solid #111;
      }

      .${highlightClass} {
        outline: 4px solid #111 !important;
        outline-offset: 5px !important;
        box-shadow: 0 0 0 8px rgba(0, 0, 0, 0.08) !important;
        border-radius: 6px !important;
        scroll-margin-top: 140px;
      }

      @media screen and (max-width: 749px) {
        #bundle-search-bar {
          margin: 8px 0 10px;
          padding: 0;
          width: 100%;
        }

        #bundle-search-form {
          flex-direction: row;
          gap: 6px;
        }

        #bundle-search-input {
          height: 40px;
          padding: 8px 36px 8px 11px;
          font-size: 13px;
        }

        #bundle-search-clear {
          width: 26px;
          min-width: 26px;
          height: 26px;
          right: 5px;
          font-size: 18px;
        }

        #bundle-search-submit {
          width: 44px;
          min-width: 44px;
          height: 40px;
        }

        #bundle-search-submit::before {
          font-size: 20px;
        }

        #bundle-search-count {
          margin-top: 5px;
          font-size: 12px;
        }

        #bundle-search-results {
          max-height: 300px;
        }

        .bundle-search-result {
          gap: 8px;
          padding: 8px;
        }

        .bundle-search-result img {
          width: 44px;
          height: 44px;
          flex-basis: 44px;
        }

        .bundle-search-result__title {
          font-size: 12px;
        }

        .bundle-search-result__meta {
          font-size: 11px;
        }

        .bundle-search-result__action {
          padding: 7px 8px;
          font-size: 10px;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function searchShopifyProducts(searchTerm) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    var searchUrl =
      root +
      'search/suggest.json?q=' + encodeURIComponent(searchTerm) +
      '&resources[type]=product' +
      '&resources[limit]=10' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,tag,product_type,vendor,variants.title,variants.sku,body';

    return fetch(searchUrl)
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Shopify search failed');
        }

        return response.json();
      })
      .then(function (data) {
        return (
          data &&
          data.resources &&
          data.resources.results &&
          data.resources.results.products
        ) || [];
      });
  }

  function findRechargeCellForShopifyProduct(product) {
    var cells = getProductCells();
    var productTitle = normalizeText(product.title || '');
    var productHandle = normalizeText(product.handle || '');
    var productHandleAsWords = normalizeText(String(product.handle || '').replace(/-/g, ' '));

    for (var i = 0; i < cells.length; i++) {
      var cell = cells[i];
      var cellText = getProductText(cell);
      var cellName = normalizeText(getProductName(cell));

      if (productTitle && cellName === productTitle) {
        return cell;
      }

      if (productTitle && cellText.includes(productTitle)) {
        return cell;
      }

      if (productHandleAsWords && cellText.includes(productHandleAsWords)) {
        return cell;
      }

      if (productHandle && cellText.includes(productHandle)) {
        return cell;
      }
    }

    return null;
  }

  function searchRechargeCellsDirectly(searchTerm) {
    var cells = getProductCells();

    return cells
      .filter(function (cell) {
        var searchableText =
          getProductName(cell) + ' ' +
          getProductText(cell);

        return relaxedTextMatches(searchTerm, searchableText);
      })
      .map(function (cell) {
        return {
          product: {
            title: getProductName(cell),
            featured_image: getProductImage(cell)
          },
          rechargeCell: cell
        };
      });
  }

  function getRechargeButtonByLabel(cell, labelToFind) {
    var buttons = cell.querySelectorAll('button');
    var wantedLabel = normalizeText(labelToFind);

    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];

      var label = normalizeText(
        button.getAttribute('aria-label') ||
        button.innerText ||
        button.textContent
      );

      if (label === wantedLabel) {
        return button;
      }
    }

    return null;
  }

  function clickRechargeButtonWithoutScrolling(button) {
    if (!button) {
      return;
    }

    button.dispatchEvent(new MouseEvent('mousedown', {
      bubbles: true,
      cancelable: true,
      view: window
    }));

    button.dispatchEvent(new MouseEvent('mouseup', {
      bubbles: true,
      cancelable: true,
      view: window
    }));

    button.click();
  }

  function productHasVariantDropdown(cell) {
    if (!cell) {
      return false;
    }

    var variantSelectors = cell.querySelectorAll(
      'select, [role="combobox"], button[aria-haspopup="listbox"], button[aria-expanded][aria-controls]'
    );

    for (var i = 0; i < variantSelectors.length; i++) {
      var selector = variantSelectors[i];

      if (selector.closest('.recharge-bundle-product-image')) {
        continue;
      }

      var label = normalizeText(
        selector.getAttribute('aria-label') ||
        selector.innerText ||
        selector.textContent
      );

      if (label === 'add' || label === 'remove') {
        continue;
      }

      return true;
    }

    return false;
  }

  function activateProductCell(cell) {
    if (!cell) {
      return;
    }

    var tabPanel = cell.closest('[role="tabpanel"]');
    var tabId = tabPanel && tabPanel.getAttribute('aria-labelledby');
    var tab = tabId && document.getElementById(tabId);

    if (tab && tab.getAttribute('aria-selected') !== 'true') {
      tab.click();
    }

    setTimeout(function () {
      cell.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      cell.classList.add(highlightClass);

      setTimeout(function () {
        cell.classList.remove(highlightClass);
      }, 4500);
    }, 650);
  }

  function addProductToBundle(cell) {
    var addButton = getRechargeButtonByLabel(cell, 'add');

    if (!addButton) {
      activateProductCell(cell);
      return;
    }

    clickRechargeButtonWithoutScrolling(addButton);

    setTimeout(function () {
      runSubmittedSearch();
    }, 800);
  }

  function renderSearchRow(item) {
    var product = item.product;
    var rechargeCell = item.rechargeCell;
    var hasVariants = productHasVariantDropdown(rechargeCell);

    var imageUrl = getShopifyProductImage(product) || getProductImage(rechargeCell);
    var title = product.title || getProductName(rechargeCell) || 'Untitled product';
    var price = getProductPrice(rechargeCell);

    var row = document.createElement('div');
    row.className = 'bundle-search-result';

    row.innerHTML = `
      ${imageUrl ? '<img src="' + escapeHtml(imageUrl) + '" alt="">' : ''}
      <div class="bundle-search-result__main">
        <div class="bundle-search-result__title">${escapeHtml(title)}</div>
        <div class="bundle-search-result__meta">
          ${hasVariants ? 'Choose options in the bundle' : (price ? escapeHtml(price) : 'Available in this bundle')}
        </div>
      </div>
      <button
        type="button"
        class="bundle-search-result__action ${hasVariants ? 'bundle-search-result__action--secondary' : ''}"
      >
        ${hasVariants ? 'View options' : 'Add'}
      </button>
    `;

    var actionButton = row.querySelector('.bundle-search-result__action');

    actionButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (hasVariants) {
        activateProductCell(rechargeCell);
      } else {
        addProductToBundle(rechargeCell);
      }
    });

    row.addEventListener('click', function () {
      activateProductCell(rechargeCell);
    });

    return row;
  }

  function renderShopifyProductResults(products, searchTerm) {
    var results = document.getElementById(searchResultsId);
    var count = document.getElementById(searchCountId);

    if (!results || !count) {
      return;
    }

    results.innerHTML = '';

    var seenCells = [];

    var shopifyMatchedProducts = products
      .map(function (product) {
        return {
          product: product,
          rechargeCell: findRechargeCellForShopifyProduct(product)
        };
      })
      .filter(function (item) {
        return !!item.rechargeCell;
      });

    var rechargeMatchedProducts = searchRechargeCellsDirectly(searchTerm);

    var availableProducts = shopifyMatchedProducts
      .concat(rechargeMatchedProducts)
      .filter(function (item) {
        if (!item.rechargeCell) {
          return false;
        }

        if (seenCells.indexOf(item.rechargeCell) !== -1) {
          return false;
        }

        seenCells.push(item.rechargeCell);

        return true;
      });

    count.textContent =
      availableProducts.length +
      ' product' +
      (availableProducts.length === 1 ? '' : 's') +
      ' found in this bundle';

    if (!availableProducts.length) {
      results.style.display = 'block';

      results.innerHTML = `
        <div class="bundle-search-result is-disabled">
          <div class="bundle-search-result__main">
            <div class="bundle-search-result__title">No products found in this bundle</div>
          </div>
        </div>
      `;

      return;
    }

    availableProducts.forEach(function (item) {
      results.appendChild(renderSearchRow(item));
    });

    results.style.display = 'block';
  }

  function clearSearchResults() {
    var results = document.getElementById(searchResultsId);
    var count = document.getElementById(searchCountId);

    if (results) {
      results.innerHTML = '';
      results.style.display = 'none';
    }

    if (count) {
      count.textContent = '';
    }
  }

  function updateClearButtonVisibility() {
    var input = document.getElementById(searchInputId);
    var clearButton = document.getElementById(searchClearId);

    if (!input || !clearButton) {
      return;
    }

    if (input.value.trim()) {
      clearButton.classList.add('is-visible');
    } else {
      clearButton.classList.remove('is-visible');
    }
  }

  function clearSearchTextAndResults() {
    var input = document.getElementById(searchInputId);

    latestSearchRequestId++;
    clearTimeout(shopifySearchTimeout);
    clearSearchResults();

    if (input) {
      input.value = '';
      input.focus();
    }

    updateClearButtonVisibility();
  }

  function scheduleTypedSearch() {
    var input = document.getElementById(searchInputId);

    clearTimeout(shopifySearchTimeout);
    clearSearchResults();
    updateClearButtonVisibility();

    /*
      This prevents old searches from appearing after the customer
      has typed something new.
    */
    latestSearchRequestId++;

    if (!input || !normalizeText(input.value)) {
      return;
    }

    shopifySearchTimeout = setTimeout(function () {
      runSubmittedSearch();
    }, searchTypingDelayMs);
  }

  function runSubmittedSearch() {
    var input = document.getElementById(searchInputId);
    var count = document.getElementById(searchCountId);

    if (!input || !count) {
      return;
    }

    var rawSearchTerm = input.value;
    var searchTerm = normalizeText(rawSearchTerm);

    clearTimeout(shopifySearchTimeout);
    clearSearchResults();
    updateClearButtonVisibility();

    if (!searchTerm) {
      return;
    }

    var requestId = ++latestSearchRequestId;

    count.textContent = 'Searching...';

    searchShopifyProducts(searchTerm)
      .then(function (products) {
        if (requestId !== latestSearchRequestId) {
          return;
        }

        renderShopifyProductResults(products, searchTerm);
      })
      .catch(function (error) {
        console.log('[Bundle search] Shopify search error:', error);

        if (requestId !== latestSearchRequestId) {
          return;
        }

        var fallbackProducts = searchRechargeCellsDirectly(searchTerm);

        renderShopifyProductResults(fallbackProducts.map(function (item) {
          return item.product;
        }), searchTerm);
      });
  }

  function findBundleCollectionControls() {
    var tabs = document.querySelector('.recharge-bundle-collection-tabs');
    var filterButton = document.querySelector('.recharge-bundle-filters-button');

    if (!tabs || !filterButton) {
      return null;
    }

    var current = tabs;
    var levelsChecked = 0;

    while (current && current !== document.body && levelsChecked < 20) {
      if (current.contains(tabs) && current.contains(filterButton)) {
        current.setAttribute('data-bundle-collection-controls', 'true');
        return current;
      }

      current = current.parentElement;
      levelsChecked++;
    }

    return null;
  }

  function getMobileHeaderOffset() {
    var possibleHeaders = document.querySelectorAll(
      'header, .site-header, .header, #shopify-section-header, .shopify-section-header-sticky'
    );

    var offset = 0;

    possibleHeaders.forEach(function (header) {
      var styles = window.getComputedStyle(header);
      var rect = header.getBoundingClientRect();

      if (
        (styles.position === 'fixed' || styles.position === 'sticky') &&
        rect.top <= 1 &&
        rect.bottom > offset
      ) {
        offset = rect.bottom;
      }
    });

    return Math.max(0, Math.round(offset));
  }

  function setupMobileFixedSearch(searchBar) {
    if (!searchBar) {
      return;
    }

    var searchPlaceholder = document.getElementById(searchPlaceholderId);

    if (!searchPlaceholder) {
      searchPlaceholder = document.createElement('div');
      searchPlaceholder.id = searchPlaceholderId;
      searchBar.insertAdjacentElement('afterend', searchPlaceholder);
    }

    var collectionControls = null;
    var collectionPlaceholder = null;
    var hasLoggedCollectionFound = false;

    var originalTop = 0;
    var ticking = false;

    function isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function findAndPrepareCollectionControls() {
      if (collectionControls && document.body.contains(collectionControls)) {
        return collectionControls;
      }

      collectionControls = findBundleCollectionControls();

      if (!collectionControls) {
        return null;
      }

      if (!hasLoggedCollectionFound) {
        console.log('[Bundle sticky] Collection tabs/filter wrapper found:', collectionControls);
        hasLoggedCollectionFound = true;
      }

      collectionPlaceholder = document.getElementById(collectionControlsPlaceholderId);

      if (!collectionPlaceholder) {
        collectionPlaceholder = document.createElement('div');
        collectionPlaceholder.id = collectionControlsPlaceholderId;
        collectionControls.insertAdjacentElement('afterend', collectionPlaceholder);
      }

      return collectionControls;
    }

    function removeFixedState() {
      searchBar.classList.remove('is-mobile-fixed');
      searchBar.style.removeProperty('--bundle-search-fixed-top');

      searchPlaceholder.style.display = 'none';
      searchPlaceholder.style.height = '0px';

      if (collectionControls) {
        collectionControls.classList.remove('is-mobile-fixed-controls');
        collectionControls.style.removeProperty('--bundle-collection-fixed-top');
      }

      if (collectionPlaceholder) {
        collectionPlaceholder.style.display = 'none';
        collectionPlaceholder.style.height = '0px';
      }
    }

    function measureOriginalPosition() {
      var wasFixed = searchBar.classList.contains('is-mobile-fixed');

      if (wasFixed) {
        removeFixedState();
      }

      findAndPrepareCollectionControls();

      originalTop = searchBar.getBoundingClientRect().top + window.pageYOffset;

      if (wasFixed) {
        updateFixedState();
      }
    }

    function updateFixedState() {
      ticking = false;

      if (!isMobile()) {
        removeFixedState();
        return;
      }

      findAndPrepareCollectionControls();

      var headerOffset = getMobileHeaderOffset();
      var shouldFix = window.pageYOffset + headerOffset >= originalTop;

      searchBar.style.setProperty('--bundle-search-fixed-top', headerOffset + 'px');

      if (shouldFix) {
        searchBar.classList.add('is-mobile-fixed');

        var fixedSearchHeight = searchBar.offsetHeight;

        searchPlaceholder.style.height = fixedSearchHeight + 'px';
        searchPlaceholder.style.display = 'block';

        if (collectionControls && collectionPlaceholder) {
          collectionControls.style.setProperty(
            '--bundle-collection-fixed-top',
            headerOffset + fixedSearchHeight + 'px'
          );

          collectionControls.classList.add('is-mobile-fixed-controls');

          collectionPlaceholder.style.height = collectionControls.offsetHeight + 'px';
          collectionPlaceholder.style.display = 'block';
        }
      } else {
        removeFixedState();
      }
    }

    function requestUpdate() {
      if (ticking) {
        return;
      }

      ticking = true;
      window.requestAnimationFrame(updateFixedState);
    }

    function delayedMeasureAndUpdate(delay) {
      setTimeout(function () {
        measureOriginalPosition();
        updateFixedState();
      }, delay);
    }

    delayedMeasureAndUpdate(300);
    delayedMeasureAndUpdate(800);
    delayedMeasureAndUpdate(1500);
    delayedMeasureAndUpdate(3000);
    delayedMeasureAndUpdate(5000);

    window.addEventListener('scroll', requestUpdate, { passive: true });

    window.addEventListener('resize', function () {
      removeFixedState();

      setTimeout(function () {
        measureOriginalPosition();
        updateFixedState();
      }, 250);
    });

    if (window.MutationObserver) {
      var observer = new MutationObserver(function () {
        if (collectionControls && document.body.contains(collectionControls)) {
          return;
        }

        findAndPrepareCollectionControls();

        if (collectionControls) {
          measureOriginalPosition();
          updateFixedState();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      setTimeout(function () {
        observer.disconnect();
      }, 15000);
    }
  }

  function injectSearchBar() {
    var titleWrapper = findChooseAtLeastTitle();

    if (!titleWrapper) {
      return false;
    }

    var existingSearchBar = document.getElementById(searchBarId);

    if (existingSearchBar) {
      existingSearchBar.remove();
    }

    injectSearchStyles();

    var searchBar = document.createElement('div');
    searchBar.id = searchBarId;

    var stickyTitleText = (
      titleWrapper.innerText ||
      titleWrapper.textContent ||
      'Choose products'
    ).trim();

    searchBar.innerHTML = `
      <div id="${searchStickyTitleId}">
        ${escapeHtml(stickyTitleText)}
      </div>

      <form id="${searchFormId}">
        <div id="${searchInputWrapId}">
          <input
            id="${searchInputId}"
            type="search"
            placeholder="Search products..."
            autocomplete="off"
          >

          <button
            type="button"
            id="${searchClearId}"
            aria-label="Clear search"
          >
            ×
          </button>
        </div>

        <button type="submit" id="${searchSubmitId}" aria-label="Search products">
          Search
        </button>
      </form>

      <div id="${searchCountId}"></div>
      <div id="${searchResultsId}"></div>
    `;

    titleWrapper.insertAdjacentElement('afterend', searchBar);

    setupMobileFixedSearch(searchBar);

    var form = document.getElementById(searchFormId);
    var input = document.getElementById(searchInputId);
    var clearButton = document.getElementById(searchClearId);

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      runSubmittedSearch();
    });

    input.addEventListener('input', function () {
      scheduleTypedSearch();
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        clearSearchTextAndResults();
      }
    });

    clearButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      clearSearchTextAndResults();
    });

    document.addEventListener('click', function (event) {
      var clickedInsideSearch = event.target.closest('#' + searchBarId);

      if (!clickedInsideSearch) {
        var results = document.getElementById(searchResultsId);

        if (results) {
          results.style.display = 'none';
        }
      }
    });

    updateClearButtonVisibility();

    console.log('[Bundle search] Hybrid compact mobile search with delayed typed search injected');

    return true;
  }

  if (!isRechargeBundlesPage()) {
    return;
  }

  var checkForTitle = setInterval(function () {
    var injected = injectSearchBar();

    if (injected) {
      clearInterval(checkForTitle);
    }
  }, 300);

  setTimeout(function () {
    clearInterval(checkForTitle);
  }, 10000);
})();